<template>
  <li>
    <a class="uk-accordion-title uk-text-small uk-padding-small uk-padding-remove-horizontal" href="#">
      How to measure?
    </a>
    <div class="uk-accordion-content">
      <img class="uk-margin-small-bottom" :data-src="currentImagePath" width="950" alt="Size Chart" data-uk-img />

      <p class="uk-text-small uk-margin-bottom">
        These are the measurements of your body (not the {{ archetype }}). To measure your arm length correctly, stand
        up straight with your arms down at your side and measure from where the shoulder meets the arm all the way down
        to your knuckles (not wrist).
      </p>

      <div class="uk-margin-bottom">
        <p class="uk-text-small">
          <strong>Example:</strong>
          <br />
          If you are 6’(183cm) tall, weigh 175lbs(80kg), chest 40’(101cm), waist 33’(84cm) we suggest size
          <strong>LARGE</strong>
        </p>

        <div class="uk-margin-bottom uk-flex">
          <label class="w-radio uk-margin-small-right uk-flex uk-flex-middle">
            <input
              id="inchesRecMenTab"
              class="uk-radio"
              style="background-size: 32px; height: 1rem; width: 1rem"
              type="radio"
              :checked="selectedLocal === 'inches'"
              @change="handleChoseLocal('inches')"
            />
            <span class="w-label">In inches</span>
          </label>

          <label class="w-radio uk-flex uk-flex-middle">
            <input
              id="cmRecMenTab"
              class="uk-radio"
              style="background-size: 32px; height: 1rem; width: 1rem"
              type="radio"
              :checked="selectedLocal === 'centimeters'"
              @change="handleChoseLocal('centimeters')"
            />
            <span class="w-label">In centimeters</span>
          </label>
        </div>
        <div class="uk-overflow-auto">
          <table class="uk-table uk-table-small uk-table-divider">
            <thead>
              <tr>
                <th />
                <th v-for="size in sizes" :key="size.id" class="uk-text-center">
                  <strong class="uk-h5 uk-text-bold">{{ size.short_name }}</strong>
                </th>
              </tr>
            </thead>
            <tbody class="uk-text-small">
              <tr v-for="row in currentRows" :key="row.field">
                <td>
                  <strong>{{ row.title }}</strong>
                </td>
                <td v-for="size in currentOptions(row.field)" :key="size.name" class="uk-text-center">
                  {{ size.label }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { sizeDataImages, sizeDataRows, sizesDataTable } from '@/web/vue/shared/constants/sizesData'

export default {
  name: 'SizeSelectionModal',
  props: {
    sizes: {
      type: Array,
      default: () => [],
    },
    gender: {
      type: String,
      default: 'male',
    },
    archetype: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chosenBackInch: '—',
      chosenBackCentimeters: '—',
      chosenChestInch: '—',
      chosenSleeveInch: '—',
      chosenChestCentimeters: '—',
      chosenSleeveCentimeters: '—',
      selectedLocal: 'inches',
    }
  },
  computed: {
    archetypeForSize() {
      let archetype = this.archetype

      if (archetype.includes('jacket')) {
        archetype = 'jacket'
      } else if (archetype.includes('croptop')) {
        archetype = 'croptop'
      }
      return archetype
    },
    currentSizes() {
      return !sizesDataTable[this.archetypeForSize] || !sizesDataTable[this.archetypeForSize][this.gender]
        ? {}
        : sizesDataTable[this.archetypeForSize][this.gender][this.selectedLocal] || {}
    },
    currentRows() {
      return sizeDataRows[this.archetypeForSize] || []
    },
    currentImagePath() {
      return sizeDataImages[this.archetype] ? sizeDataImages[this.archetype][this.gender] : ''
    },
  },
  methods: {
    currentOptions(position) {
      return this.getOptions(this.currentSizes[position])
    },
    handleChoseLocal(type) {
      this.selectedLocal = type
    },
    getOptions(options = []) {
      return options.filter(option => Boolean(this.sizes.find(s => s.name === option.name)))
    },
  },
}
</script>
